import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { CircularProgress, TablePagination, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import api from '../../api';
import FilledBtn from 'components/buttons/FilledBtn';
import DeleteModal from 'components/modal/DeleteModal';
import { useNavigate } from 'react-router';

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#EAEFEC',
    color: 'black'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14
  }
}));

const StyledTableRow = styled(TableRow)(() => ({
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));

const ITEM_HEIGHT = 48;

const roleMap = {
  fundManager: 'Fund Manager',
  investor: 'Investor',
  supportAgent: 'Support Agent',
  complianceOfficer: 'Compliance Officer',
  marketingSpecialist: 'Marketing Specialist',
  admin: 'Admin',
  superAdmin: 'Super Admin',
  financeManager: 'Finance Manager',
  other: 'Other',
}

export default function SupportTable({ loading, supportData, page, total, limit, onPageChange, onLimitChange }) {
  console.log('table list Data :>> ', supportData);
  const navigate = useNavigate();
  const [openModal, setOpenModal] = React.useState(false);
  const [tableData, setTableData] = React.useState(supportData);
  const [selectedRowData, setSelectedRowData] = React.useState(null);
  const [modalTitle, setModalTitle] = React.useState('Are you sure you want to close this ticket?');

  const handleCloseTicket = async () => {
    try {
      const response = await api.put(`/support/tickets/${selectedRowData._id}/${selectedRowData.status === 'OPEN' ? 'close' : 'reopen'}`);
      toast.success(response.data.message);
      setOpenModal(false);
      setTableData((prevData) =>
        prevData.map((ticket) =>
          ticket._id === selectedRowData._id ? { ...ticket, status: selectedRowData.status === 'OPEN' ? 'CLOSED' : 'OPEN' } : ticket
        )
      );
      toast.success('Ticket status changed successfully');
    } catch (error) {
      console.error('API error:', error);
      toast.error('Error closing ticket');
    }
  };

  React.useEffect(() => {
    setTableData(supportData);
  }, [supportData]);

  return (
    <>
      <TableContainer component={Paper}>
        {tableData && tableData.length >= 1 && !loading ? (
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>#</StyledTableCell>
                <StyledTableCell>Ticket Id</StyledTableCell>
                <StyledTableCell>Title</StyledTableCell>
                <StyledTableCell align="left">Description</StyledTableCell>
                <StyledTableCell align="left">Ticket Type</StyledTableCell>
                <StyledTableCell align="left">Role</StyledTableCell>
                <StyledTableCell align="left">Sender Name</StyledTableCell>
                <StyledTableCell align="left">Date Added</StyledTableCell>
                <StyledTableCell align="left">Status</StyledTableCell>
                <StyledTableCell align="left">Action</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData?.map((row, index) => (
                <StyledTableRow
                  key={row.id}
                  sx={{
                    backgroundColor: row.status === 'CLOSED' ? '#ffcccc' : index % 2 === 0 ? '#F9F9F9' : 'white'
                  }}
                >
                  <StyledTableCell component="th" scope="row">
                    {index + 1}
                  </StyledTableCell>
                  <StyledTableCell align="left">{row.ticketID || '—'}</StyledTableCell>
                  <StyledTableCell align="left">{row.title}</StyledTableCell>
                  <StyledTableCell align="left">{row.description}</StyledTableCell>
                  <StyledTableCell align="left">{row?.type || 'general'}</StyledTableCell>
                  <StyledTableCell align="left">{roleMap[row.userId?.role] || 'Other'}</StyledTableCell>
                  <StyledTableCell align="left">{row.userId.name}</StyledTableCell>
                  <StyledTableCell align="left">{new Date(row.createdAt).toLocaleDateString('en-GB')}</StyledTableCell>
                  <StyledTableCell align="left">
                    {row.status === 'OPEN' ? (
                      <Typography
                        sx={{
                          background: ' rgb(103, 238, 69)',
                          color: '#000',
                          padding: '5px 10px',
                          borderRadius: '5px',
                          fontSize: '14px',
                          textAlign: 'center',
                          fontWeight: 500
                        }}
                      >
                        {row.status}
                      </Typography>
                    ) : row.status === 'CLOSED' ? (
                      <Typography
                        sx={{
                          background: '#F3722C',
                          color: '#000',
                          padding: '5px 10px',
                          borderRadius: '5px',
                          fontSize: '14px',
                          textAlign: 'center',
                          fontWeight: 500
                        }}
                      >
                        {row.status}
                      </Typography>
                    ) : (
                      <Typography
                        sx={{
                          background: '#F3722C',
                          color: '#000',
                          padding: '5px 10px',
                          borderRadius: '5px',
                          fontSize: '14px',
                          textAlign: 'center',
                          fontWeight: 500
                        }}
                      >
                        {row.status}
                      </Typography>
                    )}
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      display: 'flex',
                      gap: '10px',
                      justifyContent: 'flex-start',
                      alignItems: 'center'
                    }}
                    align="left"
                  >
                    <FilledBtn
                      btnText={'View'}
                      bgColor={'#430074'}
                      fontSize={'12px'}
                      onClick={() => {
                        // setOpenModal(true);
                        navigate('/support/ticket', { state: { ticket: row } });
                      }}
                    />
                    <FilledBtn
                      btnText={row.status === 'OPEN' ? 'Close Ticket' : 'Reopen Ticket'}
                      // bgColor={row.status === 'OPEN' ? '#430074' : '#C4C4C4'} disable button logic
                      bgColor={'#430074'}
                      fontSize={'12px'}
                      // disabled={row.status !== 'OPEN'}
                      onClick={() => {
                        if (row.status === 'OPEN') {
                          setOpenModal(true);
                          setSelectedRowData(row);
                          setModalTitle('Are you sure you want to close this ticket?');
                        }
                        if (row.status === 'CLOSED') {
                          setOpenModal(true);
                          setSelectedRowData(row);
                          setModalTitle('Are you sure you want to reopen this ticket?');
                        }
                      }}
                    />
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        ) : tableData && tableData.length === 0 && loading === false ? (
          <TableBody sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <StyledTableCell colSpan={8} align="center" sx={{ borderBottom: 'none !important' }}>
              <Typography variant="h6">No Support Ticket Found</Typography>
            </StyledTableCell>
          </TableBody>
        ) : (
          <TableBody sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <StyledTableCell colSpan={8} align="center" sx={{ borderBottom: 'none !important' }}>
              <CircularProgress sx={{ color: '#430074' }} />
            </StyledTableCell>
          </TableBody>
        )}
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 50, 100]}
        component="div"
        count={total}
        rowsPerPage={limit}
        page={page}
        onPageChange={(e, newPage) => onPageChange(newPage)}
        onRowsPerPageChange={(e) => onLimitChange(parseInt(e.target.value, 10))}
      />

      <DeleteModal isOpen={openModal} title={modalTitle} onClose={() => setOpenModal(false)} onConfirm={handleCloseTicket} />
    </>
  );
}
